class TrackingSettings {
    constructor() {
        this._settings = {
            sfNumber: "",
            brandId: "",
            brandName: "",
            productId: "",
            productName: "",
            activityId: "",
            playerName: "media-amp",
            monetizedMedia: false,
            moduleName: "",
            chapters: []
        }
    }
    get toolin(){
      return this._settings.toolin;
    }
    get activityId(){
    	return this._settings.activityId;
    }
    set activityId(val=""){
    	this._settings.activityId = val;
    }
    get brandId(){
    	return this._settings.brandId;
    }
    set brandId(val=""){
    	this._settings.brandId = val;
    }
    set toolin(val=""){
      this._settings.toolin = val;
    }
    get brandName(){
    	return this._settings.brandName;
    }
    set brandName(val){
    	this._settings.brandName = val;
    }
    get chapters(){
        return this._settings.chapters;
    }
    set chapters( val = []){
        this._settings.chapters = val;
    }
    get moduleName() {
        return this._settings.moduleName;
    }
    set moduleName(val = "") {
        this._settings.moduleName = val;
    }
    get playerName(){
    	return this._settings.playerName;
    }
    set playerName(val="media-amp"){
        this._settings.playerName = val;
    }
    get productId(){
    	return this._settings.productId;
    }
    set productId(val=""){
    	this._settings.productId = val;
    }
    get productName(){
    	return this._settings.productName;
    }
    set productName(val){
    	this._settings.productName = val;
    }
    get sfNumber(){
    	return this._settings.sfNumber;
    }
    set sfNumber(val=""){
    	this._settings.sfNumber = val;
    }
}
export { TrackingSettings }
